import { render, staticRenderFns } from "./vue-tags-input.vue?vue&type=template&id=3c72c705&scoped=true&"
import script from "./vue-tags-input.vue?vue&type=script&lang=js&"
export * from "./vue-tags-input.vue?vue&type=script&lang=js&"
import style0 from "./vue-tags-input.scss?vue&type=style&index=0&id=3c72c705&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c72c705",
  null
  
)

export default component.exports